<template v-loading="loading">
  <el-form :model="post" :rules="rules" ref="formulaire" :element-loading-text="$t('posts.bienVendu.formDialogCreateTitle')">
    <ubi-page-container>
      <template v-slot:page-tabs>
        <el-tabs v-model="currentTab" type="card">
          <el-tab-pane v-for="tab in tabs"
                       :key="tab.name"
                       :label="tab.title"
                       :name="tab.name"
                       :disabled="isCreatedForm || $route.query.valueEtat === 'A'"
          >
          </el-tab-pane>
        </el-tabs>
      </template>
      <div v-show="currentTab === 'Home'" >
        <FormBienVendu :post="post" @handleActionBtnBV="handleActionBtnBV"/>
      </div>
      <div v-for="(tab, index) in tabs" :key="index">
        <div v-if="tab.name !== 'Home'" v-show="currentTab === tab.name">
          <ManagePostNetwork
              :currentTab="currentTab"
              :post="getPost"
              :networkName="tab.name"
              :fromNewPost="fromNewPost"
              :title-h3="tab.titleH3"
              :title-h4="tab.titleH4"
              :titleH3Info="tab.titleH3Info"
              :textAsideInfo1="tab.textAsideInfo1"
              :textAsideInfo2="tab.textAsideInfo2"
              :titleWarning="tab.titleWarning"
              :textWarning="tab.textWarning"
              :text-aside="tab.textAside"
              :textInfoTextarea="tab.textInfoTextarea"
              :textInfoIA="tab.textInfoIA"
              :networkEvent="getEventsAnnonce"
              :not-activated="tab.notActivated"
              :action-enregistrer="tab.analyticsEnregistrer"
              :action-annuler="tab.analyticsAnnuler"
              :possede-r-s="tab.possedeRS"
              :getCaption="tab.name === 'Home' ? '' : getCaptionsBYNetwork"
          >
          </ManagePostNetwork>
        </div>
      </div>
    </ubi-page-container>
  </el-form>
</template>

<script>
import UbiPageContainer from '@/components/PageContainer.vue'
import FormBienVendu from '@/pages/posts/BienVendu/Components/FormBienVendu.vue'
import { Tabs, TabPane } from 'element-ui'
import { mapGetters } from 'vuex'
import ManagePostNetwork from '@/pages/posts/SocialNetworkPosts/ManagePostNetwork.vue'
import { createPost, patchPost } from '@/services/posts'
import { $t } from '@/i18n'
import { getDiffuseur } from '@/helpers/functions/diffuseur'

export default {
  name: 'BienVendu',
  components: {
    ElTabs: Tabs,
    ElTabPane: TabPane,
    UbiPageContainer,
    FormBienVendu,
    ManagePostNetwork
  },
  inject: ['browserContext'],
  data () {
    return {
      post: null,
      action: null,
      currentTab: null,
      fromNewPost: false,
      tabs: [
        {
          name: 'Home',
          title: this.$t('posts.list.informationBienVendu')
        },
        {
          name: 'Instagram',
          title: 'Instagram',
          titleH3: this.$t('posts.networks.instagram.asideTitle'),
          textAside: this.$t('posts.networks.instagram.asideText'),
          titleH3Info: this.$t('posts.networks.instagram.asideInfoTitle'),
          textAsideInfo1: this.$t('posts.networks.instagram.asideInfoText1'),
          titleWarning: this.$t('posts.networks.instagram.titleWarning'),
          textWarning: this.$t('posts.networks.instagram.textWarning'),
          titleH4: this.$t('posts.networks.instagram.titleTextarea'),
          textInfoTextarea: this.$t('posts.networks.instagram.textInfoTextarea'),
          textInfoIA: this.$t('posts.networks.instagram.textInfoIA'),
          notActivated: this.$t('posts.edit.instagramOptionDisabled'),
          analyticsEnregistrer: 'enregistrer_instagram',
          analyticsAnnuler: 'annuler_instagram',
          possedeRS: false
        },
        {
          name: 'Facebook',
          title: this.$t('Facebook'),
          titleH3: this.$t('posts.networks.facebook.asideTitle'),
          textAside: this.$t('posts.networks.facebook.asideText'),
          titleH3Info: this.$t('posts.networks.facebook.asideInfoTitle'),
          textAsideInfo1: this.$t('posts.networks.facebook.asideInfoText1'),
          titleWarning: this.$t('posts.networks.facebook.titleWarning'),
          textWarning: this.$t('posts.networks.facebook.textWarning'),
          titleH4: this.$t('posts.networks.facebook.titleTextarea'),
          textInfoTextarea: this.$t('posts.networks.facebook.textInfoTextarea'),
          textInfoIA: this.$t('posts.networks.facebook.textInfoIA'),
          notActivated: this.$t('posts.facebook.notActivated'),
          analyticsEnregistrer: 'enregistrer_facebook',
          analyticsAnnuler: 'annuler_facebook',
          possedeRS: false
        },
        {
          name: 'Google',
          title: this.$t('Google Business Profile'),
          titleH3: this.$t('posts.networks.google.asideTitle'),
          textAside: this.$t('posts.networks.google.asideText'),
          titleWarning: this.$t('posts.networks.google.titleWarning'),
          textWarning: this.$t('posts.networks.google.textWarning'),
          titleH4: this.$t('posts.networks.google.titleTextarea'),
          textInfoTextarea: this.$t('posts.networks.google.textInfoTextarea'),
          textInfoIA: this.$t('posts.networks.google.textInfoIA'),
          notActivated: this.$t('posts.edit.GMBOptionDisabled'),
          analyticsEnregistrer: 'enregistrer_gmb',
          analyticsAnnuler: 'annuler_gmb',
          possedeRS: false
        },
        {
          name: 'LinkedIn',
          title: this.$t('LinkedIn'),
          titleH3: this.$t('posts.networks.linkedin.asideTitle'),
          textAside: this.$t('posts.networks.linkedin.asideText'),
          titleH3Info: this.$t('posts.networks.linkedin.asideInfoTitle'),
          textAsideInfo1: this.$t('posts.networks.linkedin.asideInfoText1'),
          titleWarning: this.$t('posts.networks.linkedin.titleWarning'),
          textWarning: this.$t('posts.networks.linkedin.textWarning'),
          titleH4: this.$t('posts.networks.linkedin.titleTextarea'),
          textInfoTextarea: this.$t('posts.networks.linkedin.textInfoTextarea'),
          textInfoIA: this.$t('posts.networks.linkedin.textInfoIA'),
          notActivated: this.$t('posts.linkedIn.notActivated'),
          analyticsEnregistrer: 'enregistrer_linkedin',
          analyticsAnnuler: 'annuler_linkedin',
          possedeRS: false
        }
      ],
      rules: {
        titre: [{ required: true, message: this.$t('validator.titleRequired'), trigger: 'blur' }],
        reference: [{ required: true, message: this.$t('validator.referenceRequired'), trigger: 'blur' }],
        code_postal: [{ required: true, message: this.$t('validator.postalCodeRequired'), trigger: 'blur' }],
        ville: [{ required: true, message: this.$t('validator.cityToShowRequired'), trigger: 'blur' }],
        surface_habitable: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        typeOffre: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        typeObjet: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        texte: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        nb_pieces_logement: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        dpe_valeur_conso: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        dpe_etiquette_conso: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        prix: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        email_a_afficher: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        telephone_a_afficher: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        contact_a_afficher: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }]
      },
      loading: false
    }
  },
  methods: {
    handleActionBtnBV (args) {
      const { action, post, typeForm } = args
      if (post.etat && post.etat !== 'V') {
        post.STATUS = 'V'
      }
      if (typeForm === 'new') {
        post.STATUS = 'V'
        this.loading = true
        this.$refs.formulaire.validate((valid) => {
          if (valid) {
            this.$confirm(
              $t('posts.bienVendu.dialogConfirmBVCreationTitle'),
              {
                confirmButtonText: $t('general.calendar.acceptedPost'),
                cancelButtonText: $t('general.calendar.refusedPost'),
                type: 'warning'
              }
            ).then(() => {
              try {
                this.loading = true
                createPost(post, this.sitimmoLogin, 'SAISIE_IMMO').then((response) => {
                  this.post.id = response.ad.id
                  this.post.typeBienLibelle = response.ad.typeBienLibelle
                  this.post.typeOffreLibelle = response.ad.typeOffreLibelle
                  this.loadCaptionInTemplate(response.ad.id, response.ad)
                  this.redirectAfterAction(action, response.ad.id)
                }).catch(() => {
                  this.$message({ message: this.$t('error.found'), type: 'error', duration: 5000 })
                  this.loading = false
                  return false
                })
                this.$message({
                  type: 'success',
                  message: $t('posts.bienVendu.creationSuccess')
                })
              } catch (e) {
                this.$message({
                  type: 'error',
                  message: $t('posts.bienVendu.creationFailed')
                })
              }
            })
          }
        })
        this.loading = false
      }
      if (typeForm === 'edit') {
        this.loading = true
        this.$confirm(
          $t('posts.bienVendu.dialogConfirmBVChangeTitle'),
          {
            confirmButtonText: $t('general.calendar.acceptedPost'),
            cancelButtonText: $t('general.calendar.refusedPost'),
            type: 'warning'
          }
        ).then(() => {
          try {
            post.STATUS = 'V'
            patchPost(post, this.sitimmoUser.login, 'SAISIE_IMMO').then((response) => {
              this.loadCaptionInTemplate(post.id, post)
              this.redirectAfterAction(action, post.id)
            }).catch(() => {
              this.$message({ message: this.$t('error.found'), type: 'error', duration: 5000 })
              this.loading = false
              return false
            })
            this.$message({
              type: 'success',
              message: $t('posts.bienVendu.modificationSuccess')
            })
          } catch (e) {
            this.$message({
              type: 'error',
              message: $t('posts.bienVendu.modificationFailed')
            })
          }
        })
        this.loading = false
      }
    },
    redirectAfterAction (action, id) {
      switch (action) {
        case 'saveAndManagePosts':
          this.$router.push({ path: `/posts/bien-vendu/${id}/edit` })
          break
        case 'saveAndManageDiffusion':
          this.$router.push({ name: 'portals-selection-post', params: { post: id } })
          break
        default:
          this.$router.push({ name: 'posts' })
      }
    },
    loadCaptionInTemplate (id, post) {
      this.$store.dispatch('caption/loadCaptions', {
        universe: this.universe,
        annonceId: id,
        bienVendu: true
      })
    }
  },
  computed: {
    ...mapGetters(['isSubUser', 'isImmo', 'isVo', 'isPromoteur', 'isCmi']),
    ...mapGetters('calendarSocialPosts', ['getListEventsByAnnonceByNetwork']),
    ...mapGetters('caption', ['getCaptionByNetwork']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    job () {
      return this.sitimmoUser.metier
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    username () {
      return this.user.username
    },
    typeOffre () {
      return this.post.typeOffre
    },
    typeObjet () {
      return this.post.typeObjet
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    possedeInstagramBV () {
      return this.user.haveInstagramBV
    },
    possedeGMBBV () {
      return this.user.haveGMBBV
    },
    possedeFacebookBV () {
      return this.user.haveFacebookBV
    },
    possedeLinkedInBV () {
      return this.user.haveLinkedInBV
    },
    getEventsAnnonce () {
      return this.getListEventsByAnnonceByNetwork(this.currentTab)
    },
    getPost () {
      return this.$store.getters['bienVendu/getPost']
    },
    getCaptionsBYNetwork () {
      if (this.currentTab === 'Home') {
        return
      }
      const diffuseur = getDiffuseur(this.currentTab, this.universe, true)
      return this.getCaptionByNetwork(diffuseur, this.$route.params.id)
    },
    isCreatedForm () {
      return this.$route.name.split('-')[0] === 'new'
    },
    isEditForm () {
      return this.$route.name.split('-')[0] === 'edit'
    }
  },
  mounted () {
    if (this.$route.query.network && this.$route.query.bienVendu) {
      const redirectTab = this.tabs.filter((tab) => tab.name.toUpperCase() === this.$route.query.network.toUpperCase())
      this.currentTab = redirectTab[0].name
    }
    if (this.isEditForm && this.$route.params.id) {
      this.$store.dispatch('calendarSocialPosts/loadEventsByAnnonce', this.$route.params.id)
    }

    this.action = this.$route.name.split('-')[0]
    if (this.action === 'edit' || this.action === 'new') {
      this.currentTab = 'Home'
    }
    if (this.$route.params.id) {
      this.$store.dispatch('bienVendu/loadPost', this.$route.params.id).then(() => {
        if (this.isEditForm) {
          this.post = {
            id: this.$route.params.id,
            titre: this.getPost.titre,
            reference: this.getPost.reference,
            prix_vendu_net: (this.getPost.prix) ? this.getPost.prix : '',
            honoraires_negociation: null,
            honoraires_negociation_vendeur: null,
            surface_habitable: (this.getPost.donnees.surface_habitable) ? this.getPost.donnees.surface_habitable.valeur : '',
            texte: this.getPost.texte,
            typeObjet: this.getPost.typeObjet,
            dpe_etiquette_conso: (this.getPost.donnees.dpe_etiquette_conso) ? this.getPost.donnees.dpe_etiquette_conso.valeur : '',
            dpe_valeur_conso: (this.getPost.donnees.dpe_valeur_conso) ? this.getPost.donnees.dpe_valeur_conso.valeur : '',
            email_a_afficher: (this.getPost.donnees.email_a_afficher) ? this.getPost.donnees.email_a_afficher.valeur : '',
            numero_voie: (this.getPost.donnees.numero_voie) ? this.getPost.donnees.numero_voie.valeur : '',
            type_voie: (this.getPost.donnees.type_voie) ? this.getPost.donnees.type_voie.valeur : '',
            nom_voie: (this.getPost.donnees.nom_voie) ? this.getPost.donnees.nom_voie.valeur : '',
            code_postal: (this.getPost.donnees.code_postal) ? this.getPost.donnees.code_postal.valeur : '',
            ville: (this.getPost.donnees.ville) ? this.getPost.donnees.ville.valeur : '',
            origine_acquereur: (this.getPost.donnees.origine_acquereur) ? this.getPost.donnees.origine_acquereur.valeur : '',
            date_compromis: (this.getPost.donnees.date_compromis) ? this.getPost.donnees.date_compromis.valeur : '',
            telephone_a_afficher: (this.getPost.donnees.telephone_a_afficher) ? this.getPost.donnees.telephone_a_afficher.valeur : '',
            typeOffre: 'V'
          }
        }
      })
      this.loadCaptionInTemplate(this.$route.params.id, this.post)
    }
  },
  beforeMount () {
    this.tabs[1].possedeRS = this.possedeInstagramBV
    this.tabs[2].possedeRS = this.possedeFacebookBV
    this.tabs[3].possedeRS = this.possedeGMBBV
    this.tabs[4].possedeRS = this.possedeLinkedInBV

    if (this.$route.params.linkSocialPosts === true) {
      this.fromNewPost = true
    }

    this.post = {
      id: null,
      titre: null,
      reference: null,
      prix_vendu_net: null,
      honoraires_negociation: null,
      honoraires_negociation_vendeur: null,
      surface_habitable: null,
      status: 'B',
      texte: null,
      typeObjet: null,
      dpe_etiquette_conso: null,
      dpe_valeur_conso: null,
      email_a_afficher: null,
      telephone_a_afficher: null,
      typeOffre: 'V'
    }
  }
}
</script>
